<template>
    <v-app>
    <PublicHeader/>
    <v-main>
        <v-container class="px-0" fluid>

            <v-parallax
                height="280"
                src="@/assets/material.png">
                <v-row
                align="center"
                justify="center">
                <v-col
                    class="text-center"
                    cols="12">
                    <h1 class="text-h3 font-weight-light">Simple pricing plans<br/>for blockchain APM & business analysis</h1>
                </v-col>
                </v-row>
            </v-parallax>

            <v-tabs centered class="my-10">
                <v-tab>For Deployment</v-tab>
                <v-tab>For Developer</v-tab>
                <v-tab-item>
                    <v-container fluid>
                        <v-row justify="center" class="mt-10 px-10">
                            <v-col cols=3>
                                <v-card min-height="400">
                                    <v-card-title class="text-uppercase text-h4">Startup</v-card-title>
                                    <v-card-text>
                                        <div class="package">
                                            <div class="package-layout">
                                                <div class="package-currency">$</div>
                                                <div class="package-value">
                                                    <div class="value black--text">0.23</div>
                                                </div>
                                            </div>
                                            <div class="period text-center">/ per data collector hour</div>
                                        </div>

                                        <!-- <div class="text-h6 black--text font-weight-light">For businesses who start to build, test and run production blockchain solutions</div> -->
                                        <div class="mt-5 text-subtitle-1">
                                            <ul>
                                                <li>Membership fee $299 per month</li>
                                                <li>4 vCPUs or fewer</li>
                                                <li>7 days data retention</li>
                                            </ul>
                                        </div>
                                    </v-card-text>                    
                                </v-card>
                            </v-col>
                            <v-col cols=3>
                                <v-card min-height="400">
                                    <v-card-title class="text-uppercase text-h4">Growth</v-card-title>
                                    <v-card-text>
                                        <div class="package">
                                            <div class="package-layout">
                                                <div class="package-currency">$</div>
                                                <div class="package-value">
                                                    <div class="value black--text">0.46</div>
                                                </div>
                                            </div>
                                            <div class="period text-center">/ per data collector hour</div>
                                        </div>

                                        <!-- <div class="text-h6 black--text font-weight-light">For businesses who start to build, test and run production blockchain solutions</div> -->
                                        <div class="mt-5 text-subtitle-1">
                                            <ul>
                                                <li>Membership fee $299 per month</li>
                                                <li>8 vCPUs or fewer</li>
                                                <li>30 days data retention</li>
                                            </ul>
                                        </div>
                                    </v-card-text>                    
                                </v-card>
                            </v-col>
                            <v-col cols=3>
                                <v-card min-height="400">
                                    <v-card-title class="text-uppercase text-h4">Preimum</v-card-title>
                                    <v-card-text>
                                        <div class="package">
                                            <div class="package-layout">
                                                <div class="package-currency">$</div>
                                                <div class="package-value">
                                                    <div class="value black--text">0.92</div>
                                                </div>
                                            </div>
                                            <div class="period text-center">/ per data collector hour</div>
                                        </div>

                                        <!-- <div class="text-h6 black--text font-weight-light">For businesses who start to build, test and run production blockchain solutions</div> -->
                                        <div class="mt-5 text-subtitle-1">
                                            <ul>
                                                <li>Membership fee $299 per month</li>
                                                <li>16 vCPUs or fewer</li>
                                                <li>90 days data retention</li>
                                            </ul>
                                        </div>
                                    </v-card-text>                    
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row justify="center" class="mt-10 px-10">
                            <v-col cols=3>
                                <v-card min-height="400">
                                    <v-card-title class="text-uppercase text-h4" >Developer</v-card-title>
                                    <v-card-text >
                                        <div class="package">
                                            <div class="package-layout">
                                                <div class="package-currency">$</div>
                                                <div class="package-value">
                                                    <div class="value black--text">99</div>
                                                </div>
                                            </div>
                                            <div class="period text-center">/ month</div>
                                        </div>

                                        <div class="mt-5 text-subtitle-1">
                                            <ul>
                                                <li>30-day free trial</li>
                                                <li>48 hours data retention</li>
                                                <li>A Developer License is bound to a single developer</li>
                                            </ul>
                                        </div>
                                    </v-card-text>                    
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>                
                </v-tab-item>
            </v-tabs>
        </v-container>
    </v-main>
    <Footer/>
    </v-app>
</template>

<script>

  import Footer from '@/components/Footer.vue'
  import PublicHeader from '@/components/PublicHeader.vue'
  
  export default {
      components: {
        PublicHeader, Footer
      },
      data() {
          return {
              toggle_exclusive: 0
          };
      },
      computed: {
      },
      created() {
      },
      methods: {
      }
  };

</script>

<style scoped lang="scss">

.package {

    .period {
        padding: 0 0 5px 4px;
        font-size: 1.125rem;
        font-weight: 300;
        margin-bottom: 2rem;
    }

    .package-layout {
        display: flex;
        justify-content: center;
        padding: 2rem 2rem 0;

        .package-currency {
            padding-right: 4px;
            font-size: 1.5rem;
            font-weight: 500;
        }
        
        .package-value {
            display: flex;
            align-items: flex-end;

            .value {
                font-size: 4.5rem;
                font-weight: 300;
                line-height: 1;
            }
        
        }    
    }

}

</style>